export default {
    errorMessage: "abcd",
    hdrStatusCode: null,
    txnStatusCode: null,
    message: "",
    groupId: null,
    patientPaidAmount: null,
    totalPaidAmount: null,
    notEligibileFlag: false,
    priorAuthFlag: false,
    patientNotFoundFlag: false,
    calcNDC: "1234567890",
    isPAIndicator: "No",
    requestType: "",
    rejectCode1: "52",
    internalErrorCodes1: "15752",
    externalConditionCode: "REVISE_INPUT",
    internalConditionCode: "Non-Matched Cardholder ID",
    tReqId: "WEB00000000000058610"
  }

// export default [
//   {
//     errorMessage: null,
//     hdrStatusCode: null,
//     txnStatusCode: null,
//     message: "Non matched cardholder id.",
//     groupId: null,
//     patientPaidAmount: null,
//     totalPaidAmount: null,
//     notEligibileFlag: false,
//     priorAuthFlag: false,
//     patientNotFoundFlag: false,
//   },
// ];



// [
//   {
//     errorMessage: null,
//     hdrStatusCode: null,
//     txnStatusCode: null,
//     message: "Non matched cardholder id.",
//     groupId: null,
//     patientPaidAmount: null,
//     totalPaidAmount: null,
//     notEligibileFlag: false,
//     priorAuthFlag: false,
//     patientNotFoundFlag: true,
//   },
// ];
// {"errorMessage":null,"hdrStatusCode":null,"txnStatusCode":null,"message":"Invalid Beneficiary information. Please try again","groupId":null,"patientPaidAmount":null,"totalPaidAmount":null,"notEligibileFlag":false,"priorAuthFlag":false,"patientNotFoundFlag":false}